import {
    attr,
    Model,
    many,
    oneToOne,
} from 'redux-orm';
import generateRandomString from '%app/js/common/services/generateRandomString';
import { OBJECT_TYPE_HALL } from '%paysera_seat_selection/js/seatSelection/config/constants';
import polygon from '%paysera_seat_selection/js/seatSelection/redux/model/defaults/polygon';

class Hall extends Model {
    static modelName = 'Hall';

    static fields = {
        id: attr(),
        name: attr(),
        entityId: attr({ getDefault: () => null }),
        sectors: many('Sector'),
        roundTables: many('RoundTable'),
        rectangleTables: many('RectangleTable'),
        generalAdmissions: many('GeneralAdmission'),
        shapes: many('Shape'),
        configuration: oneToOne('Configuration'),
        hash: attr({ getDefault: () => generateRandomString() }),
        objectType: attr({ getDefault: () => OBJECT_TYPE_HALL }),
        polygon: attr({ getDefault: () => ({ ...polygon }) }),
        cacheKey: attr({ getDefault: () => generateRandomString() }),
        optimized: attr({ getDefault: () => false }),
    };

    toString() {
        return `Hall: ${this.id}`;
    }
}

export default Hall;
